@if (me && !isLoading) {
  <div class="pinned">
    <h1>{{ 'accountsettings' | translate }}</h1>
  </div>
  <article DualAxis class="card-like" (scroll)="scroll.fireScrollChange($event)">
    @if (!me.email_verified_at) {
      <div>
        <h2><nb-icon icon="email-outline"></nb-icon>{{ 'verifyemail' | translate }}</h2>
        <p>{{ 'currentlyverify' | translate:{value: me.username} }}</p>
        <button nbButton status="primary" (click)="verify()">{{ 'sendverifyemail' | translate }}</button>
      </div>
    }
    <div>
      <h2><nb-icon icon="lock-outline"></nb-icon>{{ (me.has_password ? 'resetpassword' : 'createpassword') | translate }}</h2>
      <p>{{ (!me.has_password ? 'currentlynopassword' : 'currentlypassword') | translate:{value: (lastPasswordReset && lastPasswordReset.sent_at ? lastPasswordReset.sent_at : me.created_at) | date:'longDate'} }}</p>
      @if (passwordResetting != null) {
        <p>
          <nb-icon icon="alert-circle-outline" status="primary"></nb-icon>&nbsp;{{ 'currentlyresetting' | translate }}
        </p>
      }
      <button nbButton (click)="resetPassword()" status="primary" [disabled]="passwordResetting != null">{{ 'setpassword' | translate }}</button>
    </div>
    @if (me.provider_id && me.provider) {
      <div>
        <h2><nb-icon icon="linkedin-outline"></nb-icon>{{ (me.provider_id && me.provider ? 'linkedinconnected' : 'linkedinconnect') | translate }}</h2>
        @if (me.provider_id && me.provider) {
          <p>{{ 'currentlylinkedin' | translate:{value: me.provider_username, provider: me.provider} }}</p>
        }
        @if (!(me.provider_id && me.provider)) {
          <p>{{ 'currentlynolinked' | translate }}</p>
        }
        @if (me.provider_id && me.provider) {
          <div class="connect-row">
            <nb-user [picture]="me.provider_avatar" [name]="me.provider_username"></nb-user>
            <button status="danger" nbButton size="small" (click)="removeSocial(me.provider)">{{ 'removelinkedin' | translate }}</button>
          </div>
        }
        <!--      <div class="non-connect-row" *ngIf="!me.provider_id || me.provider === 'google'">-->
<!--        <a class="social-button linkedin" [href]="'/auth/linkedin/login?redirect=settings&with='+me.key">-->
<!--          <nb-icon icon="linkedin"></nb-icon><span>{{ 'connecttolinkedin' | translate }}</span>-->
<!--        </a>-->
<!--      </div>-->
<!--      <div class="non-connect-row" *ngIf="!me.provider_id || me.provider === 'linkedin'">-->
<!--        <a class="social-button linkedin" [href]="'/auth/google/login?redirect=settings&with='+me.key">-->
<!--          <nb-icon pack="custom-icons" icon="google"></nb-icon><span>{{ 'connecttogoogle' | translate }}</span>-->
<!--        </a>-->
<!--      </div>-->
    </div>
}
    <div>
      <h2><nb-icon icon="shield-outline"></nb-icon>{{ 'legal' | translate }}</h2>
      <p>{{ 'currentlylegal' | translate }}</p>
      <p><a href="assets/files/flix_it_privacy_policy.pdf" target="_blank">{{ 'privacypolicy' | translate }}</a></p>
      <p><a href="assets/files/flix_it_terms_of_service.pdf" target="_blank">{{ 'termsconditions' | translate }}</a></p>
      <h3>{{ 'cv.retention.title' | translate }}</h3>
      <p>{{ 'cv.retention.what_text' | translate }}</p>
      <p>{{ 'cv.retention.when_text' | translate }}</p>
      <p>{{ 'cv.retention.where_text' | translate }}</p>
    </div>
    <div>
      <h2><nb-icon icon="download-outline"></nb-icon>{{ 'downloadme' | translate }}</h2>
      <p>{{ 'currentlydownloadme' | translate }}</p>
      <button nbButton status="basic" (click)="downloadme()">{{ 'download' | translate }}</button>
    </div>
    <div>
      <h2><nb-icon icon="trash-2-outline"></nb-icon>{{ 'deleteme' | translate }}</h2>
      @if (me.email_verified_at) {
<p><nb-icon status="success" icon="checkmark-circle-2-outline"></nb-icon>&nbsp;{{ ('accountverifiedon' | translate:{value: (me.email_verified_at | date:'longDate')}) }}</p>
}
      @if (me.user_to_client?.reviewed_at) {
<p><nb-icon [status]="me.user_to_client?.status === UserStatus.ACTIVE ? 'success' : 'danger'" [icon]="me.user_to_client?.status === UserStatus.ACTIVE ? 'checkmark-circle-2-outline' : 'close-circle-outline'"></nb-icon>&nbsp;{{ ('accountreviewed' | translate:{value: (me.user_to_client?.reviewed_at | date:'longDate')}) }}</p>
}
      <p>{{ 'currentlydeleteaccount' | translate }}</p>
      <button nbButton status="danger" (click)="deleteme()" [disabled]="auth.isStaffer">{{ 'deleteme' | translate }}</button>
      @if (deleteRefused) {
<p class="refused">{{ deleteRefused }}</p>
}
    </div>
  </article>

}
